import axios from "axios";
import { toast } from "sonner";

const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 402) {
      // FR-1.7: never redirect silently — show the message with a way through
      err._billing402 = true;
      toast.error(err?.response?.data?.detail || "Your trial has ended — subscribe to continue", {
        duration: 8000,
        action: { label: "Subscribe", onClick: () => { window.location.href = "/settings?billing=required"; } },
      });
    }
    return Promise.reject(err);
  }
);

export function toastErr(e) {
  if (e?._billing402) return; // interceptor already showed the subscribe message
  toast.error(fmtErr(e));
}

export function fmtErr(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Something went wrong.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (x && typeof x.msg === "string" ? x.msg : JSON.stringify(x))).join(" ");
  if (d && typeof d.msg === "string") return d.msg;
  return String(d);
}

export const fmtMoney = (n) => `$${Number(n || 0).toFixed(2)}`;
export const fmtDate = (d) => {
  if (!d) return "";
  // bare YYYY-MM-DD is a calendar day, not a UTC instant — parse as local noon to avoid day-shift
  const dt = d.length === 10 ? new Date(`${d}T12:00:00`) : new Date(d);
  return dt.toLocaleDateString(undefined, { weekday: "short", month: "short", day: "numeric" });
};
export const fmtDateShort = (d) => {
  if (!d) return "";
  const dt = d.length === 10 ? new Date(`${d}T12:00:00`) : new Date(d);
  return dt.toLocaleDateString(undefined, { month: "short", day: "numeric" });
};
export const todayLocal = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
};
export const fmtTime = (d) => (d ? new Date(d).toLocaleTimeString(undefined, { hour: "numeric", minute: "2-digit" }) : "");

export const photoSrc = (p) => (!p ? "" : String(p).startsWith("data:") ? p : `${process.env.REACT_APP_BACKEND_URL}/api/files/${p}`);

export default api;
